import { useMemo } from 'react';

import { CompoundSelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { SelectItemGroupLabel } from '@/components/form/baseInputs/SelectInput/SelectItemGroupLabel';
import { useDualGrantorOptions } from '@/hooks/useDualGrantorOptions';
import { HypotheticalInsuranceTransferTaxKind } from '@/types/schema';

export function useInsurancePolicyPremiumTransferTaxTypeOptions(): CompoundSelectInputOption<string>[] {
  const grantorOptions = useDualGrantorOptions();

  return useMemo<CompoundSelectInputOption<string>[]>(() => {
    return [
      {
        type: 'component',
        component: <SelectItemGroupLabel label="Non-taxable gifts" />,
      },
      {
        display: 'Annual exclusion gift with Crummey powers',
        value:
          HypotheticalInsuranceTransferTaxKind.AnnualExclusionGiftWithCrummeyPowers,
      },
      {
        display: 'Non-taxable transfer',
        value: HypotheticalInsuranceTransferTaxKind.NonTaxable,
      },
      {
        component: <SelectItemGroupLabel label="Taxable gift from" />,
        type: 'component',
      },
      ...grantorOptions,
    ];
  }, [grantorOptions]);
}
